<script lang="ts">
    import { node_decreaseHeight, node_decreaseWidth, node_increaseHeight, node_increaseWidth, node_rename, node_setIsStart } from "../actions/machineState";
    import type { MachineStateMealy } from "../state/machineState";
    import { getUpdateMachineState } from "./context";
    const updateMachineProgramState = getUpdateMachineState();

    export let machineState: MachineStateMealy;
    $: uiState = machineState.uiState;
    $: node = machineState.machine.nodes[uiState.selection.stateId];

    function handleNameChange(event) {
        updateMachineProgramState(node_rename(machineState, uiState.selection.stateId, event.target.value));
    }

    function handleIsStartClicked() {
        if (!node.isStart) {
            updateMachineProgramState(node_setIsStart(machineState, uiState.selection.stateId));
        }
    }

    function handleDecreaseWidthClicked() {
        updateMachineProgramState(node_decreaseWidth(machineState, uiState.selection.stateId));
    }

    function handleIncreaseWidthClicked() {
        updateMachineProgramState(node_increaseWidth(machineState, uiState.selection.stateId));
    }

    function handleDecreaseHeightClicked() {
        updateMachineProgramState(node_decreaseHeight(machineState, uiState.selection.stateId));
    }

    function handleIncreaseHeightClicked() {
        updateMachineProgramState(node_increaseHeight(machineState, uiState.selection.stateId));
    }
</script>

<div style="position: absolute; bottom: 0px; left: 0px; border: 2px solid lightgrey; padding: 5px; margin: 5px; background-color: white; border-radius: 10px;">    
    <!-- <div><input on:input = {handleNameChange} value={node.name}/></div> -->
    <div><textarea on:input = {handleNameChange} rows="2" cols="20" value={node.name}></textarea></div>
    <div><button on:click={handleIsStartClicked}>als Startzustand verwenden</button></div>
    {#if node.type === 'NodeRect'}
    <div><button on:click={handleDecreaseWidthClicked} >-</button>Breite: {node.width}<button on:click={handleIncreaseWidthClicked} >+</button></div>
    <div><button on:click={handleDecreaseHeightClicked}>-</button>Höhe: {node.height} <button on:click={handleIncreaseHeightClicked}>+</button></div>
    {/if}
</div>

<style>
    button {
        margin: 4px;
        padding: 4px;
        border: 1px solid #ccc;
        border-radius: 2px;
        color: #000000;
    }
</style>